import get from 'lodash/get'

const isActiveAsset = (asset: string) => (item: unknown) => {
  return (get(item, 'asset') || '').toLowerCase() === asset.toLowerCase()
}

export default isActiveAsset
